export const socialsData = {
    github: 'https://github.com/Deepankar0712',
    linkedIn: 'https://www.linkedin.com/in/deepankar-sharma-7bba521a5',
    dribble: 'https://dribbble.com/deepankar07/collections',
    // hackerrank: 'https://www.hackerrank.com/engineerprerna02',
}